import { render, staticRenderFns } from "./Gathering.vue?vue&type=template&id=25e8628c&scoped=true&"
import script from "./Gathering.vue?vue&type=script&lang=js&"
export * from "./Gathering.vue?vue&type=script&lang=js&"
import style0 from "./Gathering.vue?vue&type=style&index=0&id=25e8628c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e8628c",
  null
  
)

export default component.exports